import React, { PropsWithChildren } from 'react';

import clsx from 'clsx';

import { Message, Text } from '@atoms';

import classes from './radio-item.module.scss';

export type RadioItemProps = PropsWithChildren<{
  checked?: boolean;
  message?: Message;
  className?: string;
  value: string | number | boolean;
  onClick?: () => void;
  bigger?: boolean;
}>;

export const RadioItem = ({
  checked,
  message,
  onClick,
  bigger,
  className,
  children,
}: RadioItemProps) => {
  return (
    <div
      className={clsx(
        className,
        classes.item,
        checked && classes.checked,
        bigger && classes.bigger,
      )}
      role="button"
      onClick={() => onClick && onClick()}
    >
      {children ? (
        children
      ) : (
        <Text
          element="span"
          type="reduced"
          color="inherit"
          margin={[0, 0, 0, 10]}
          message={message || { id: 'radio_item_message' }}
        />
      )}
    </div>
  );
};
